export const InfoChip = ({ children }) => (
  <span className="inline-flex items-center h-6 px-3 rounded-[4px] bg-white border border-gray-300 text-[12px] leading-none font-['Poppins'] text-gray-700 whitespace-nowrap max-w-[200px] overflow-hidden text-ellipsis">
    {children}
  </span>
);
